export default __webpack_public_path__ + "static/3d-react-ts-book-9244c57e5aa4293e8bf129a4a67b7891.png";